import { createLucideIcon } from "lucide-react";

export const Calendar = createLucideIcon(
    "Calendar",
    [
        [
            "path",
            {
                d: "M11.9955 13H12.0045",
                key: "i6bckf",
            },
        ],
        [
            "path",
            {
                d: "M11.9955 17H12.0045",
                key: "1io74n",
            },
        ],
        [
            "path",
            {
                d: "M15.991 13H16",
                key: "1mx9o7",
            },
        ],
        [
            "path",
            {
                d: "M18 2V4",
                key: "2mhpwu",
            },
        ],
        [
            "path",
            {
                d: "M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z",
                key: "11atia",
            },
        ],
        [
            "path",
            {
                d: "M3 8H21",
                key: "1iukdm",
            },
        ],
        [
            "path",
            {
                d: "M3.5 8H20.5",
                key: "otvk0m",
            },
        ],
        [
            "path",
            {
                d: "M6 2V4",
                key: "18ytj9",
            },
        ],
        [
            "path",
            {
                d: "M8 13H8.009",
                key: "tmooiy",
            },
        ],
        [
            "path",
            {
                d: "M8 17H8.009",
                key: "1pf90k",
            },
        ],
    ],
);
